import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { MessageCircle, Phone, ArrowUpRight } from "lucide-react";
import { SITE } from "../data/site";

// Persistent mobile contact bar — Call / WhatsApp / Request Survey always
// reachable after the first screen. Mobile/tablet only (navbar CTA is xl+).
// Hidden on the survey page itself. No intrusive desktop popup anywhere.
export function MobileCta() {
  const [show, setShow] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    let ticking = false;
    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        setShow(window.scrollY > window.innerHeight * 0.85);
        ticking = false;
      });
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (pathname.startsWith(SITE.cta.to)) return null;

  const phone = SITE.contact.phone.replace(/\s/g, "");
  const wa = SITE.contact.whatsapp.replace(/\s/g, "").replace("+", "");

  return (
    <div
      data-testid="mobile-sticky-cta"
      aria-hidden={!show}
      className={`fixed inset-x-0 bottom-0 z-30 border-t border-zinc-200 bg-white/95 backdrop-blur-xl transition-transform duration-300 xl:hidden ${
        show ? "translate-y-0" : "translate-y-full"
      }`}
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
    >
      <div className="grid grid-cols-3 gap-px bg-zinc-200">
        <a
          href={`tel:${phone}`}
          data-testid="mobile-sticky-call-btn"
          tabIndex={show ? 0 : -1}
          className="flex min-h-[52px] items-center justify-center gap-2 bg-white font-mono text-xs uppercase tracking-[0.18em] text-charcoal"
        >
          <Phone size={14} aria-hidden="true" className="text-dcc" /> Call
        </a>
        <a
          href={`https://wa.me/${wa}`}
          target="_blank" rel="noopener noreferrer"
          data-testid="mobile-sticky-whatsapp-btn"
          tabIndex={show ? 0 : -1}
          className="flex min-h-[52px] items-center justify-center gap-2 bg-white font-mono text-xs uppercase tracking-[0.18em] text-charcoal"
        >
          <MessageCircle size={14} aria-hidden="true" className="text-dcc" /> WhatsApp
        </a>
        <Link
          to={SITE.cta.to}
          data-testid="mobile-sticky-survey-btn"
          tabIndex={show ? 0 : -1}
          className="flex min-h-[52px] items-center justify-center gap-1.5 bg-dcc font-mono text-xs uppercase tracking-[0.18em] text-white"
        >
          Survey <ArrowUpRight size={13} aria-hidden="true" />
        </Link>
      </div>
    </div>
  );
}
